'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _reactRedux = require('react-redux');

var _quicksend = require('redux/modules/quicksend');

var quicksendActions = _interopRequireWildcard(_quicksend);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _Modal = require('components/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _QuickSendForwardForm = require('./QuickSendForwardForm');

var _QuickSendForwardForm2 = _interopRequireDefault(_QuickSendForwardForm);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var QuickSendForwardPopup = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    prop: state.quicksend.prop
  };
}, (0, _extends3.default)({}, quicksendActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(QuickSendForwardPopup, _Component);

  function QuickSendForwardPopup() {
    (0, _classCallCheck3.default)(this, QuickSendForwardPopup);
    return (0, _possibleConstructorReturn3.default)(this, (QuickSendForwardPopup.__proto__ || (0, _getPrototypeOf2.default)(QuickSendForwardPopup)).apply(this, arguments));
  }

  (0, _createClass3.default)(QuickSendForwardPopup, [{
    key: 'onHide',
    value: function onHide() {
      var onHide = this.props.onHide;

      onHide();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          show = _props.show,
          id = _props.id,
          data = _props.data,
          onForward = _props.onForward;

      var modalProps = {
        backdrop: true,
        closeByEsc: false,
        title: t('Forward'),
        bsSize: 'lg'
      };

      return _react2.default.createElement(
        _Modal2.default,
        (0, _extends3.default)({}, modalProps, { show: show, onHide: this.onHide }),
        _react2.default.createElement(_QuickSendForwardForm2.default, { id: id, data: data, onForward: onForward })
      );
    }
  }]);
  return QuickSendForwardPopup;
}(_react.Component), _class3.propTypes = {
  data: _propTypes2.default.object,
  id: _propTypes2.default.number,
  onForward: _propTypes2.default.func,
  onHide: _propTypes2.default.func,
  show: _propTypes2.default.bool,
  t: _propTypes2.default.func
}, _class3.defaultProps = {
  data: {},
  onForward: _noop3.default,
  onHide: _noop3.default
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onHide', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onHide'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = QuickSendForwardPopup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/QuickSend/QuickSendForwardPopup.js
// module id = 2074
// module chunks = 1